import { render, staticRenderFns } from "./LiteratureItem.vue?vue&type=template&id=9e588870&scoped=true&"
import script from "./LiteratureItem.vue?vue&type=script&lang=js&"
export * from "./LiteratureItem.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureItem.vue?vue&type=style&index=0&id=9e588870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e588870",
  null
  
)

export default component.exports